import React, { ReactElement, ReactNode } from 'react'
import useDetailTabs from 'src/component-layout/DetailTabs/useDetailTabs'
import { useTranslate } from 'src/localization/Trns'

import * as style from './TransactionDetailTabs.style'

export type TransactionDetailTab = 'overview' | 'activities'

interface TransactionDetailTabsProps {
  activeTab: TransactionDetailTab
  activities: ReactNode
  header: ReactNode
  overview: ReactNode
  onTabChange: (tab: TransactionDetailTab) => void
}

const TABS: TransactionDetailTab[] = ['overview', 'activities']

const TransactionDetailTabs = ({
  activeTab,
  activities,
  header,
  overview,
  onTabChange,
}: TransactionDetailTabsProps): ReactElement => {
  const translate = useTranslate()
  const { getPanelProps, getTabProps } = useDetailTabs({
    activeTab,
    onTabChange,
    tabs: TABS,
  })

  return (
    <div css={style.container}>
      <div css={style.header}>{header}</div>
      <div
        css={style.tabList}
        role="tablist"
        aria-label={translate('Transaction Details')}
      >
        {TABS.map((tab) => {
          const label = tab === 'overview' ? 'Overview' : 'Activity'

          return (
            <button
              key={tab}
              {...getTabProps(tab)}
              css={style.tab}
            >
              {translate(label)}
            </button>
          )
        })}
      </div>
      <div
        {...getPanelProps('overview')}
        css={[style.panel, style.overviewPanel]}
      >
        {overview}
      </div>
      <div
        {...getPanelProps('activities')}
        css={style.panel}
      >
        {activities}
      </div>
    </div>
  )
}

export default TransactionDetailTabs
